export enum TipoPagamento {
  PIX = "PIX",
  BOLETO = "BOLETO",
}
